import moment from 'moment';

export const searchFormat = 'YYYY-MM-DD';

export const defaultPeriod = [
  moment().startOf('month').format(searchFormat),
  moment().format(searchFormat),
];
